import * as React from 'react';
import styles from './index.less';
import Link from '../../components/link';
import wrapStore from '../../utils/wrap-store';
import FooterStore from './store';
import cx from 'classnames';
import LanguageSelect from '../common-language-select';
import ToTopBtn from '@src/business-components/to-top-btn';
import CookieTips from './components/cookie-tips';

const LinkableImage = ({ src, url, index }) => {
  if (!src) return null;

  return url ? (
    <Link href={url} target="_blank" key={index}>
      <img src={src} />
    </Link>
  ) : (
    <img key={index} src={src} />
  );
};

// 渲染认证Logo列表
const CertificationLogos = ({ logos }) => (
  <React.Fragment>{logos.map((logo, index) => <LinkableImage key={index} src={logo.img} url={logo.url} index={index} />)}</React.Fragment>
);

// 渲染协议链接列表
const AgreementLinks = ({ links, onCookieSetting }) => (
  <div className={styles.footer_agreem_list}>
    {links.filter(item => item.text).map((item, index, filteredArray) => (
      <React.Fragment key={index}>
        {item.href ? (
          <Link href={item.href} target="_blank" className={item.isFontWeight && styles.fontWeight}>
            {item.text}
          </Link>
        ) : (
          <Link onClick={() => item.cookieSetting && onCookieSetting()}>{item.text}</Link>
        )}
        {index < filteredArray.length - 1 && <span className={styles.agreem_line}>|</span>}
      </React.Fragment>
    ))}
  </div>
);

// 渲染右侧Logo列表
const RightLogos = ({ logos }) => (
  <div className={styles.r_logo}>
    {logos.map((logo, index) => (
      <React.Fragment key={index}>
        <LinkableImage src={logo.img} url={logo.url} index={index} />
        {index < logos.length - 1 && <div className={styles.logo_line} />}
      </React.Fragment>
    ))}
  </div>
);

const Footer = ({ store }) => {
  store.use();

  return (
    <React.Fragment>
      <CookieTips store={store.cookieTipsStore} />
      <div
        className={cx(styles.footer, {
          [styles.rootAct]: store.isActive,
          [styles.rootAct1]: store.isActive && store.isWaterfallLayout
        })}
      >
        <div className={styles.footer_container}>
          <div className={styles.footer_top}>
            <div className={styles.footer_information_container}>
              {/* 官方工具 */}
              <ul className={styles.information_title}>
                {store.footerLinks.map((section, index) => (
                  <li key={index}>
                    <span className={styles.information_title_content}>{section.title}</span>
                    <div className={styles.information_list}>
                      {section.items.map((item, itemIndex) => (
                        <div key={itemIndex} className={styles.information_list_content}>
                          {item.href ? (
                            <Link href={item.href} target="_blank">
                              {item.text}
                            </Link>
                          ) : (
                            item.text
                          )}
                        </div>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* 语言选择 */}
            <LanguageSelect buttonDisplay={'footer'} store={store.selectStore} />

            {/* 回到顶部 */}
            <div className={styles.topBtn}>
              <ToTopBtn store={store.toTopBtnStore} />
            </div>
          </div>
          <div className={styles.footer_bottom}>
            <div className={styles.l_bottom}>
              <AgreementLinks links={store.agreementLinks} onCookieSetting={() => store.handleCookieSetting()} />
              {store.footerTextInfo.filter(item => item.text).map((item, index) => (
                <div key={index} className={styles.footer_copyright}>
                  {item.href ? (
                    <Link href={item.href} target="_blank">
                      {item.text}
                    </Link>
                  ) : (
                    item.text
                  )}
                </div>
              ))}
            </div>
            <div className={styles.r_bottom}>
              <div className={styles.truste}>
                <CertificationLogos logos={store.footerLeftLogo} />
              </div>
              <RightLogos logos={store.footerRightLogo} />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default wrapStore(Footer, FooterStore);
